/**
 * kult-analytics.js — Reichweitenmessung mit Umami (eigener Server) und Event-Katalog der Kult-Werkzeuge
 * (docs/requirements/2026-10-03-analytics-konzept.md §3, §6, §8). Geladen von snippets/kult-analytics.liquid (defer,
 * nach kult-consent.js). Konfiguration: <script id="kult-analytics-config"> (Theme-Einstellungen „Kult Analytics“).
 *
 * Laden: <host>/kult.js mit data-website-id, data-do-not-track, data-auto-track, data-exclude-search="false",
 *   data-before-send="kultUmamiBeforeSend", data-domains (Shop-Domains). Modus „consent“: erst nach Einwilligung
 *   Analyse (kultConsent.allowed); Modus „always“: sofort, außer der Besucher hat Analyse ausdrücklich abgelehnt.
 *   Spätere Einwilligung (Event kult:consent) lädt nach; Widerruf stoppt das Senden im before-send-Hook.
 * Bereinigung: kq, token, key, email und alle Werte mit „@“ werden vor dem Senden aus URL und Referrer entfernt;
 *   weitere Seitenaufrufe auf demselben Pfad (replaceState von Finder/Filtern) zählen nicht doppelt.
 * Events (§6, ohne personenbezogene Daten): zubereitung, finder_ergebnis, warenkorb, probierset, kult_box,
 *   bedarfsrechner, suche, suche_leer, newsletter, checkout, b2b_anfrage, seminar_termin.
 *   Quellen: bestehende Events (kult:method:changed, kult:cart:add, kult:cart:updated) und DOM-Beobachtung;
 *   bestehende Skripte bleiben unverändert.
 * Firmenbesuche (§5, nur mit Setting kult_b2b_visits und Einwilligung Analyse): POST <b2bHost>/besuch
 *   {path, title, referrer} einmal je Seitenaufruf auf den Firmenkunden-Templates.
 */
(function () {
  'use strict';
  if (window.__kultAnalytics) return;
  window.__kultAnalytics = true;

  var cfg = {};
  try {
    var cfgEl = document.getElementById('kult-analytics-config');
    cfg = cfgEl ? JSON.parse(cfgEl.textContent || '{}') : {};
  } catch (e) { cfg = {}; }
  if (!cfg.mode || cfg.mode === 'off') return;

  /* Nicht messen (29.10.2026): Vorschau/Dev-Theme, automatisierte Browser und Bots, interne Geräte.
     Intern abmelden: einmal eine Seite mit ?kult_intern=an öffnen (zurück mit ?kult_intern=aus); setzt den Umami-eigenen
     Schalter umami.disabled im lokalen Speicher dieses Browsers. */
  try {
    var intern = new URLSearchParams(location.search).get('kult_intern');
    if (intern === 'an') localStorage.setItem('umami.disabled', '1');
    else if (intern === 'aus') localStorage.removeItem('umami.disabled');
  } catch (e) { /* ohne lokalen Speicher */ }
  var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  var ua = String(navigator.userAgent || '');
  var ausgeschlossen = (role && role !== 'main') || /\.myshopify\.com$/i.test(location.hostname) || navigator.webdriver === true ||
    /headless|bot|crawl|spider|slurp|lighthouse|pagespeed|preview|prerender|phantom|puppeteer|playwright/i.test(ua);
  try { if (localStorage.getItem('umami.disabled')) ausgeschlossen = true; } catch (e) { /* ohne lokalen Speicher */ }
  if (ausgeschlossen) return;

  var STRIP = ['kq', 'token', 'key', 'email'];
  var B2B_TEMPLATES = ['firmenkunden', 'buerokaffee', 'firmenpraesente', 'kaffee-catering', 'team-events', 'kaffee-mit-logo', 'firmenpraesente-anlass', 'firmengeschenke-weihnachten', 'firmengeschenke-mitarbeiter', 'firmengeschenke-kunden', 'firmengeschenke-mit-logo', 'firmenkunden-info', 'firmenkunden-faq', 'firmenkonto'];
  var host = cleanHost(cfg.host);
  var siteId = /^[0-9a-f-]{8,64}$/i.test(String(cfg.siteId || '').trim()) ? String(cfg.siteId).trim() : '';
  var b2bHost = cleanHost(cfg.b2bHost);

  var loading = false;
  var loaded = false;
  var failed = false;
  var queue = [];
  var pending = [];
  var b2bSent = false;
  var lastPath = null;
  var lastCart = null;
  var lastClick = { el: null, t: 0 };
  var lastInput = 0;
  var lastMethod = '';
  var lastFinder = '';
  var lastCheckout = 0;
  var seminarSent = false;

  function cleanHost(value) {
    var h = String(value || '').trim().replace(/\/+$/, '');
    if (/^https:\/\/[a-z0-9.-]+(:\d+)?$/i.test(h)) return h;
    if (/^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(h)) return h;
    return '';
  }

  /* ---------- Einwilligung ---------- */
  function consent() { return window.kultConsent || null; }

  function trackingAllowed() {
    var kc = consent();
    if (cfg.mode === 'always') return !(kc && typeof kc.declined === 'function' && kc.declined('analytics'));
    return !!(kc && kc.allowed('analytics'));
  }

  /* ---------- Bereinigung ---------- */
  function cleanUrl(u) {
    if (!u || typeof u !== 'string') return u;
    try {
      var abs = /^https?:\/\//i.test(u);
      var url = new URL(u, location.origin);
      var drop = [];
      url.searchParams.forEach(function (value, key) {
        if (STRIP.indexOf(key.toLowerCase()) > -1 || String(value).indexOf('@') > -1) drop.push(key);
      });
      if (!drop.length) return u;
      drop.forEach(function (key) { url.searchParams.delete(key); });
      var q = url.searchParams.toString();
      var rest = url.pathname + (q ? '?' + q : '') + url.hash;
      return abs ? url.origin + rest : rest;
    } catch (e) { return u; }
  }

  function pathOf(u) {
    try { return new URL(u, location.origin).pathname; } catch (e) { return String(u || ''); }
  }

  function sanitize(data) {
    var out = {};
    if (!data || typeof data !== 'object') return out;
    Object.keys(data).forEach(function (k) {
      var v = data[k];
      if (v === undefined || v === null || v === '') return;
      if (typeof v === 'number') { if (isFinite(v)) out[k] = v; return; }
      if (typeof v === 'boolean') { out[k] = v ? 'ja' : 'nein'; return; }
      v = String(v).trim();
      if (!v) return;
      if (v.indexOf('@') > -1) v = '[entfernt]';
      out[k] = v.slice(0, 80);
    });
    return out;
  }

  window.kultUmamiBeforeSend = function (type, payload) {
    try {
      if (!trackingAllowed()) return false;
      if (!payload || typeof payload !== 'object') return payload;
      if (payload.url) payload.url = cleanUrl(payload.url);
      if (payload.referrer) payload.referrer = cleanUrl(payload.referrer);
      if (type === 'event' && !payload.name) {
        var path = pathOf(payload.url || location.pathname);
        if (lastPath !== null && path === lastPath) return false;
        lastPath = path;
      }
      return payload;
    } catch (e) { return payload; }
  };

  /* ---------- Tracker ---------- */
  function flush() {
    if (!window.umami || typeof window.umami.track !== 'function') return;
    queue.splice(0).forEach(function (item) {
      try { window.umami.track(item[0], item[1]); } catch (e) { /* ignorieren */ }
    });
  }

  function loadUmami() {
    if (loaded || loading || failed || !host || !siteId) return;
    loading = true;
    try {
      var s = document.createElement('script');
      s.src = host + '/kult.js';
      s.async = true;
      s.setAttribute('data-website-id', siteId);
      s.setAttribute('data-do-not-track', 'true');
      s.setAttribute('data-auto-track', 'true');
      s.setAttribute('data-exclude-search', 'false');
      s.setAttribute('data-before-send', 'kultUmamiBeforeSend');
      var domains = String(cfg.domains || '').split(',').filter(function (d) { return d && !/\.myshopify\.com$/i.test(d); }).join(',');
      if (domains) s.setAttribute('data-domains', domains);
      s.onload = function () { loaded = true; loading = false; flush(); };
      s.onerror = function () { loading = false; failed = true; queue = []; };
      document.head.appendChild(s);
    } catch (e) { loading = false; }
  }

  function track(name, data) {
    try {
      if (!trackingAllowed() || !host || !siteId) return;
      var clean = sanitize(data);
      if (window.umami && typeof window.umami.track === 'function') { window.umami.track(name, clean); return; }
      if (failed) return;
      loadUmami();
      if (queue.length < 30) queue.push([name, clean]);
    } catch (e) { /* nie nach außen werfen */ }
  }

  /* Ereignisse beim Laden der Seite (z. B. Suche): warten, bis die Einwilligung da ist */
  function onceAllowed(fn) {
    if (trackingAllowed()) { try { fn(); } catch (e) { /* ignorieren */ } } else pending.push(fn);
  }

  function evaluate() {
    try {
      if (trackingAllowed()) {
        loadUmami();
        pending.splice(0).forEach(function (fn) { try { fn(); } catch (e) { /* ignorieren */ } });
      }
      sendB2B();
    } catch (e) { /* ignorieren */ }
  }

  /* ---------- Firmenbesuche ---------- */
  function sendB2B() {
    if (b2bSent || !cfg.b2bVisits || !b2bHost) return;
    if (B2B_TEMPLATES.indexOf(String(cfg.template || '')) < 0 && !/-b2b$/.test(String(cfg.template || ''))) return;
    var kc = consent();
    if (!kc || !kc.allowed('analytics')) return;
    if (navigator.doNotTrack === '1' || window.doNotTrack === '1') return;
    if (typeof window.fetch !== 'function') return;
    b2bSent = true;
    var ref = '';
    try { if (document.referrer) { var r = new URL(document.referrer); ref = r.origin + r.pathname; } } catch (e) { ref = ''; }
    var body = JSON.stringify({ path: location.pathname, title: String(document.title || '').slice(0, 200), referrer: ref });
    var url = b2bHost + '/besuch';
    var opts = { method: 'POST', mode: 'cors', keepalive: true, credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: body };
    try {
      window.fetch(url, opts).catch(function () {
        /* Ältere Browser: keepalive mit CORS-Preflight nicht unterstützt → ohne keepalive wiederholen */
        var retry = { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: body };
        return window.fetch(url, retry);
      }).catch(function () { /* Server nicht erreichbar: still */ });
    } catch (e) { /* ignorieren */ }
  }

  /* ---------- Kontext ---------- */
  var SOURCES = [
    ['[class*="kult-pdp-sampler"], [class*="kult-sampler"]', 'probierset'],
    ['[class*="kult-gifts-voucher"]', 'gutschein'],
    ['kult-gift-builder, .kult-gift-builder, [class*="kult-gb"]', 'konfigurator'],
    ['[class*="kult-b2b"]', 'b2b'],
    ['[class*="kult-finder"]', 'finder'],
    ['.kult-club-rechner, [class*="kult-club-konfigurator"]', 'rechner'],
    ['[class*="kult-sem-"]', 'seminar'],
    ['[class*="kult-home-reorder"], [class*="kult-account"], [class*="kult-acc-"]', 'nachkauf'],
    ['[class*="kult-home-bestseller"]', 'bestseller'],
    ['[class*="kult-cart"], cart-drawer, [class*="cart-drawer"]', 'warenkorb'],
    ['[class*="product-card"], [class*="product-tile"], [class*="kult-plp"], [class*="kult-home"]', 'karte'],
    ['[class*="kult-pdp"], product-form, [class*="product-information"]', 'pdp']
  ];

  function recentClick(ms) {
    return lastClick.el && Date.now() - lastClick.t < ms ? lastClick.el : null;
  }

  function sourceOf(el) {
    if (el && el.closest) {
      for (var i = 0; i < SOURCES.length; i++) {
        try { if (el.closest(SOURCES[i][0])) return SOURCES[i][1]; } catch (e) { /* ungültiger Selektor */ }
      }
    }
    var t = String(cfg.templateName || '');
    if (t === 'product') return 'pdp';
    if (t === 'collection') return 'karte';
    return t || 'seite';
  }

  function cartItems(cart) { return cart && Array.isArray(cart.items) ? cart.items : null; }

  function addedItems(prev, next) {
    var items = cartItems(next);
    if (!items || !items.length) return [];
    if (!prev && Number(cfg.cartCount) === 0) prev = { items: [] };
    if (!prev) {
      var top = items[0];
      return [{ item: top, qty: top.quantity || 1 }];
    }
    var before = {};
    (cartItems(prev) || []).forEach(function (it) { before[it.key] = it.quantity || 0; });
    var out = [];
    items.forEach(function (it) {
      var delta = (it.quantity || 0) - (before[it.key] || 0);
      if (delta > 0) out.push({ item: it, qty: delta });
    });
    return out;
  }

  function euros(cents) { return Math.round(Number(cents || 0)) / 100; }

  function firstNumber(text) {
    var m = String(text || '').replace(/\.(?=\d{3}\b)/g, '').match(/\d+(?:,\d+)?/);
    return m ? parseFloat(m[0].replace(',', '.')) : undefined;
  }

  /* ---------- Bestehende Events ---------- */
  document.addEventListener('kult:method:changed', function (e) {
    try {
      var method = e.detail && e.detail.method;
      if (!method || method === lastMethod) return;
      lastMethod = method;
      if (Date.now() - lastInput > 5000) return; /* nur echte Auswahl, keine Vorbelegung beim Laden */
      var src = sourceOf(recentClick(5000));
      var ort = src === 'karte' && cfg.templateName === 'collection' ? 'plp' : src;
      if (ort === 'karte' && cfg.templateName === 'index') ort = 'startseite';
      track('zubereitung', { methode: method, ort: ort });
    } catch (err) { /* ignorieren */ }
  });

  document.addEventListener('kult:cart:add', function (e) {
    try {
      var d = (e && e.detail) || {};
      var quelle = sourceOf(recentClick(20000));
      var data = { quelle: quelle };
      var cart = cartItems(d.cart) ? d.cart : null;
      if (cart) {
        var added = addedItems(lastCart, cart);
        if (added.length) {
          var first = added[0].item;
          data.produkt = first.handle;
          data.variante = first.variant_title || first.variant_id;
          data.menge = added.reduce(function (n, a) { return n + a.qty; }, 0);
          if (added.length > 1) data.positionen = added.length;
        }
        if (quelle === 'probierset' && added.length) {
          var sum = added.reduce(function (n, a) {
            var unit = a.item.final_price || a.item.price || 0;
            return n + unit * a.qty;
          }, 0);
          track('probierset', { sorten: added.length, summe: euros(sum) });
        }
        lastCart = cart;
      }
      track('warenkorb', data);
    } catch (err) { /* ignorieren */ }
  });

  document.addEventListener('kult:cart:updated', function (e) {
    try { if (e.detail && cartItems(e.detail.cart)) lastCart = e.detail.cart; } catch (err) { /* ignorieren */ }
  });

  /* ---------- Klicks (Capture: vor den Handlern der Werkzeuge) ---------- */
  function onCheckout() {
    if (Date.now() - lastCheckout < 3000) return;
    lastCheckout = Date.now();
    var data;
    if (lastCart && cartItems(lastCart)) {
      var abo = cartItems(lastCart).some(function (it) { return !!it.selling_plan_allocation; });
      data = { wert: euros(lastCart.total_price), positionen: lastCart.item_count, abo: abo ? 'ja' : 'nein' };
    } else {
      data = { wert: euros(cfg.cartTotal), positionen: Number(cfg.cartCount) || 0, abo: cfg.cartAbo ? 'ja' : 'nein' };
    }
    track('checkout', data);
  }

  function onRechner(root, btn) {
    var modeInput = root.querySelector('[data-mode]:checked');
    var modus = btn.getAttribute('data-modus') || (modeInput ? modeInput.value : '');
    var gramm = btn.getAttribute('data-gramm');
    if (!gramm) {
      var amountEl = modus === 'menge' ? root.querySelector('[data-amount-value]') : root.querySelector('[data-sum-need]');
      gramm = firstNumber(amountEl && amountEl.textContent);
    }
    var rhythmEl = root.querySelector('[data-rhythm-select]');
    var rhythmus = btn.getAttribute('data-rhythmus') || (rhythmEl ? rhythmEl.value : '');
    track('bedarfsrechner', { modus: modus, gramm: gramm ? Number(gramm) : undefined, rhythmus: rhythmus ? Number(rhythmus) || rhythmus : undefined });
  }

  function onGiftBox(builder) {
    var items = builder && Array.isArray(builder.items) ? builder.items : [];
    var cents = items.reduce(function (n, it) { return n + (Number(it && it.price) || 0); }, 0);
    cents += Number(builder && builder.getAttribute('data-box-price')) || 0;
    var anlass = (builder && builder.occasion) || '';
    if (!anlass && builder) {
      var pressed = builder.querySelector('[data-gb-occasion][aria-pressed="true"]');
      anlass = pressed ? pressed.getAttribute('data-gb-occasion') : '';
    }
    track('kult_box', { positionen: items.length || undefined, budget: cents ? Math.round(cents / 100) : undefined, anlass: anlass });
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      lastClick = { el: t, t: Date.now() };
      lastInput = Date.now();

      if (t.closest('a[href="/checkout"], a[href^="/checkout?"], [name="checkout"]')) { onCheckout(); return; }

      var rechner = t.closest('.kult-club-rechner');
      var rBtn = rechner && t.closest('[data-rechner-submit], [data-cta]');
      if (rBtn && !rBtn.disabled) { onRechner(rechner, rBtn); return; }

      var gbBtn = t.closest('[data-gb-submit]');
      if (gbBtn && !gbBtn.disabled) { onGiftBox(gbBtn.closest('kult-gift-builder, .kult-gift-builder')); return; }

      var term = t.closest('[data-sem-term]');
      if (term && !seminarSent && term.getAttribute('aria-disabled') !== 'true') { seminarSent = true; track('seminar_termin', {}); return; }

      var news = t.closest('[data-acc-news-switch]');
      if (news && !news.disabled && news.getAttribute('aria-checked') === 'false') track('newsletter', { ort: 'konto' });
    } catch (err) { /* ignorieren */ }
  }, true);

  ['keydown', 'change'].forEach(function (type) {
    document.addEventListener(type, function () { lastInput = Date.now(); }, true);
  });

  /* ---------- Formulare ---------- */
  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var valid = typeof form.checkValidity === 'function' ? form.checkValidity() : true;
      if (!valid) return;

      var tags = form.querySelector('input[name="contact[tags]"]');
      if (tags && /newsletter/i.test(tags.value || '')) {
        var ort = cfg.templateName || 'seite';
        if (form.closest('footer, [class*="kult-footer"]') || form.id === 'kult-newsletter-form') ort = 'footer';
        else if (form.closest('[class*="kult-home-newsletter"]')) ort = 'startseite';
        else if (String(cfg.templateName || '').indexOf('customers') === 0) ort = 'konto';
        track('newsletter', { ort: ort });
        return;
      }

      // Firmenanfragen zählt erst die Erfolgsmeldung kult:b2b:sent (unten), nicht der Klick auf „Absenden“
      if (form.matches('.kult-evreq__form') || form.querySelector('[data-kult-track^="b2b:"]') || form.closest('[class*="kult-b2b-form"]')) return;

      var builder = form.closest('kult-gift-builder, .kult-gift-builder');
      if (builder) { onGiftBox(builder); return; }

      var rechner = form.closest('.kult-club-rechner');
      if (rechner) onRechner(rechner, form);
    } catch (err) { /* ignorieren */ }
  }, true);

  /* ---------- Firmenanfrage: nur erfolgreich übermittelte, je Formular und Seitenaufruf einmal ---------- */
  var b2bGezaehlt = typeof WeakSet === 'function' ? new WeakSet() : null;
  document.addEventListener('kult:b2b:sent', function (e) {
    try {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (b2bGezaehlt) { if (b2bGezaehlt.has(form)) return; b2bGezaehlt.add(form); }
      var art = 'b2b';
      if (form.matches('.kult-evreq__form')) art = 'event';
      else {
        var btn = form.querySelector('[data-kult-track^="b2b:"]');
        art = (btn && String(btn.getAttribute('data-kult-track')).split(':')[1]) || cfg.template || 'b2b';
      }
      track('b2b_anfrage', { art: art, interesse: e.detail && e.detail.interesse });
    } catch (err) { /* ignorieren */ }
  });

  /* ---------- Kaffeefinder ---------- */
  function reportFinder() {
    try {
      var p = new URLSearchParams(location.search);
      var data = { methode: p.get('z'), staerke: p.get('s'), aroma: p.get('a'), extra: p.get('e') };
      var cups = parseInt(p.get('t'), 10);
      if (cups > 0) data.tassen = cups;
      if (!data.methode && !data.staerke && !data.aroma) return;
      var key = [data.methode, data.staerke, data.aroma, data.extra, data.tassen].join('|');
      if (key === lastFinder) return;
      lastFinder = key;
      track('finder_ergebnis', data);
    } catch (e) { /* ignorieren */ }
  }

  function watchFinder() {
    var result = document.querySelector('[data-finder-result]');
    if (!result || typeof MutationObserver !== 'function') return;
    var check = function () { if (!result.hidden) window.setTimeout(reportFinder, 80); };
    try { new MutationObserver(check).observe(result, { attributes: true, attributeFilter: ['hidden'] }); } catch (e) { return; }
    check();
  }

  /* ---------- Suche ---------- */
  function reportSearch() {
    if (cfg.templateName !== 'search') return;
    var term = String(cfg.searchTerms || '').trim();
    if (!term) return;
    var params = new URLSearchParams(location.search);
    if (parseInt(params.get('page'), 10) > 1) return; /* Folgeseiten nicht doppelt zählen */
    var count = Number(cfg.searchCount);
    if (!(count >= 0)) {
      var countEl = document.querySelector('.kult-search-head__count');
      count = firstNumber(countEl && countEl.textContent);
    }
    var begriff = term.toLowerCase();
    var data = { begriff: begriff, typ: params.get('type') || 'alle' };
    if (typeof count === 'number' && isFinite(count)) data.treffer = count;
    onceAllowed(function () {
      track('suche', data);
      if (count === 0) track('suche_leer', { begriff: begriff });
    });
  }

  /* ---------- Start ---------- */
  function init() {
    try { watchFinder(); } catch (e) { /* ignorieren */ }
    try { reportSearch(); } catch (e) { /* ignorieren */ }
    var kc = consent();
    if (kc && typeof kc.ready === 'function') kc.ready(evaluate);
    else evaluate();
    document.addEventListener('kult:consent', evaluate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
